import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import VehicleListingFilters from '../../../components/VehicleListingFilters'
import buildPath from '../../../../lib/cars/used/path-builder'
import Layout from '../../../components/Layout'
import Helmet from 'react-helmet'
import { getChangedVehicles } from '../../../lib/changed-vehicles-retriever'

const UserCarIndex = (props) => {
  const data = useStaticQuery(graphql`
    query UsedCarIndexQuery {
      allUsedVehicleCatfish(
        filter: {
          category: { in: ["car", "lifestyle"] }
          expiredDate: { eq: null }
          state: { eq: "Published" }
        }
      ) {
        totalCount
        edges {
          ...usedVehicleFields
        }
      }
      allOfferCatfish(filter: { state: { eq: "Published" } }) {
        edges {
          node {
            offerTitle
            offerDescription
            usedVehicle {
              _id
            }
          }
        }
      }
    }
  `)

  const { location, serverData } = props
  const serverVehicles =
    serverData && serverData.vehicles ? serverData.vehicles : []
  const offerIndex =
    data.allOfferCatfish &&
    data.allOfferCatfish.edges &&
    data.allOfferCatfish.edges.length > 0
      ? data.allOfferCatfish.edges
          .map(({ node }) => node)
          .reduce((collection, offer) => {
            if (offer.usedVehicle && offer.usedVehicle.length > 0) {
              for (const vehicle of offer.usedVehicle) {
                if (vehicle._id) {
                  collection[vehicle._id] = {
                    offerTitle: offer.offerTitle,
                    offerDescription: offer.offerDescription
                  }
                }
              }
            }
            return collection
          }, {})
      : {}

  const vehicles =
    data.allUsedVehicleCatfish &&
    data.allUsedVehicleCatfish.edges
      .map(({ node }) => node)
      .map((vehicle) => {
        const serverVehicle =
          serverVehicles.find((v) => v._id === vehicle._id) || {}

        return {
          ...vehicle,
          ...serverVehicle
        }
      })
      .map((vehicle) => {
        const hpMonthlyPayment = vehicle.hpFinance.monthlyPayment
        const pcpMonthlyPayment = vehicle.pcpFinance.monthlyPayment
        let monthlyPayment = hpMonthlyPayment

        if (
          pcpMonthlyPayment &&
          (!hpMonthlyPayment || hpMonthlyPayment > pcpMonthlyPayment)
        ) {
          monthlyPayment = pcpMonthlyPayment
        }

        const offer = offerIndex[vehicle._id]

        return {
          ...vehicle,
          locationName: vehicle.dealership.shortName,
          onOffer: !!offer,
          offerTitle: offer && offer.offerTitle,
          offerDescription: offer && offer.offerDescription,
          path: buildPath('car', vehicle),
          monthlyPayment,
          roadTax: vehicle.taxInfo ? vehicle.taxInfo.price : null
        }
      })

  for (const vehicle of serverVehicles) {
    const vehicleIndex = vehicles.findIndex((v) => v._id === vehicle._id)

    if (vehicleIndex === -1) {
      vehicles.push({
        ...vehicle,
        locationName: vehicle.dealership.shortName,
        onOffer: false,
        path: buildPath('car', vehicle),
        monthlyPayment: vehicle.hpFinance.monthlyPayment,
        roadTax: vehicle.taxInfo ? vehicle.taxInfo.price : null
      })
    }
  }

  return (
    <Layout location={location}>
      <Helmet title="Used Cars" />
      {vehicles ? (
        <VehicleListingFilters total={vehicles.length} vehicles={vehicles} />
      ) : (
        <p>No cars found</p>
      )}
    </Layout>
  )
}

export const usedVehicleFields = graphql`
  fragment usedVehicleSummaryWidgetFields on UsedVehicleCatfishEdge {
    node {
      _id
      id: _id
      brand
      model
      category
      derivative
      registration
      value
      hpFinance {
        monthlyPayment
      }
      pcpFinance {
        monthlyPayment
      }
      fuel
      year
      image
      bodyStyle
      featured
      seats
      isSold
      expiredDate
      taxInfo {
        price
      }
    }
  }
  fragment usedVehicleFields on UsedVehicleCatfishEdge {
    node {
      _id
      id: _id
      brand
      model
      category
      derivative
      dealership {
        shortName
      }
      registration
      colour
      mileage
      value
      transmission
      transmissionStyle
      engineSize
      fuel
      year
      image
      bodyStyle
      featured
      seats
      features
      interior {
        label
        value
      }
      exterior {
        label
        value
      }
      mpg
      co2
      bhp
      expiredDate
      reservedDate
      hpFinance {
        monthlyPayment
        carPrice
        depositAmount
        adminFee
        balanceToFinance
        firstPayment
        numberOfPayments
        finalPayment
        amountPayable
        interestCharges
        interestApr
        interestRate
        optionFee
        lender
      }
      pcpFinance {
        monthlyPayment
        carPrice
        depositAmount
        adminFee
        balanceToFinance
        firstPayment
        numberOfPayments
        finalPayment
        amountPayable
        interestCharges
        interestApr
        interestRate
        optionFee
        lender
      }
      isSold
      manufacturerColour
      taxInfo {
        price
      }
      onSale
    }
  }
`
export default UserCarIndex

export const getServerData = () => {
  return getChangedVehicles('car')
}
